import { render, staticRenderFns } from "./ProductNotesDialog.vue?vue&type=template&id=bd758374&scoped=true&lang=pug&"
import script from "./ProductNotesDialog.vue?vue&type=script&lang=ts&"
export * from "./ProductNotesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProductNotesDialog.vue?vue&type=style&index=0&id=bd758374&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd758374",
  null
  
)

export default component.exports